module.exports = __webpack_public_path__ + "static/step1-b5504f29e88b924f20927ecf0c449f1a.png";